<div class="modal-footer justify-content-between">
  <button *ngIf="showCancel" type="button" class="btn btn-light" [disabled]="cancelDisabled"
    (click)="onCancelClick.emit()">
    {{ cancelLabel }}
  </button>
  <button type="submit" class="btn btn-primary" [disabled]="saveDisabled" *ngIf="showSave">
    {{ saveLabel }}
  </button>
</div>